<template>
  <TabTemplate>
    <template v-slot:chart>
      <SoilCompositionLineChart chartRef="soil-wedge"></SoilCompositionLineChart>
    </template>
    <template v-slot:content>
      <SoilProfileWedgeTable></SoilProfileWedgeTable>
    </template>
  </TabTemplate>
</template>
<script>
import SoilProfileWedgeTable from '@/components/soil-profile-wedges/SoilProfileWedgeTable.vue'
import SoilCompositionLineChart from '@/components/soilcomposition/SoilCompositionLineChart.vue'
import TabTemplate from '@/components/common/TabTemplate.vue'

export default {
  name: 'SoilProfileWedgesTab',
  components: {
    SoilProfileWedgeTable,
    SoilCompositionLineChart,
    TabTemplate
  }
}
</script>
